import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ContextService } from 'src/app/api/services/context.service';
import { State } from 'src/app/core/state/core.state';
import { CreateContextRequestBuilder } from 'src/app/shared/components/redirection/product/builders/create-context-request.builder';
import { ERROR_404_PATH } from 'src/app/shared/constants/route.constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html'
})
export class ProductComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<State>,
    private contextService: ContextService
  ) {}
  async ngOnInit(): Promise<void> {
    const productCode = 'HE';
    const partnerCode = this.route.snapshot.paramMap.get('partnerCode');
    let distributorCode = environment.brand;
    try {
      distributorCode =
        this.route.snapshot.paramMap.get('productCode')?.split('_')[1].slice(0, 2) ??
        environment.brand;
    } catch (e) {
      distributorCode = environment.brand;
    }

    const requestBody = new CreateContextRequestBuilder()
      .withProduit(productCode)
      .withCodeVendeur(distributorCode)
      .withPartnerCode(partnerCode)
      .build();

    let authorize = JSON.parse(environment.authorizeProspectBrands) as string[];

    if (authorize.some(m => m == environment.brand))
      this.contextService.createContext(requestBody).subscribe(result => {
        const url = new URL(result);
        this.store.dispatch({ type: '[Store] Reset' });
        this.router.navigate([url.pathname.replace('MRH/', '')]);
      });
    else this.router.navigate([ERROR_404_PATH]);
  }
}
